/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formtype_Options_Salesproposals2Inputs */

const ja_contact_formtype_options_salesproposals2 = /** @type {(inputs: Contact_Formtype_Options_Salesproposals2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貴社サービスのご紹介`)
};

const en_contact_formtype_options_salesproposals2 = /** @type {(inputs: Contact_Formtype_Options_Salesproposals2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales proposals`)
};

/**
* | output |
* | --- |
* | "Sales proposals" |
*
* @param {Contact_Formtype_Options_Salesproposals2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formtype_options_salesproposals2 = /** @type {((inputs?: Contact_Formtype_Options_Salesproposals2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formtype_Options_Salesproposals2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formtype_options_salesproposals2(inputs)
	return en_contact_formtype_options_salesproposals2(inputs)
});
export { contact_formtype_options_salesproposals2 as "contact_formType_options_salesProposals" }